module.exports = "https://static.wagwalking.com/_next/static/images/Avatar-1-56a9327a9614e92a96446487f68477da.svg";